interface FileErrorToastProps {
  error: string | null;
  onClose: () => void;
}

function FileErrorToast({ error, onClose }: FileErrorToastProps) {
  if (!error) return null;

  return (
    <div
      className="fixed top-4 right-4 z-50 text-white px-4 py-3 rounded-lg shadow-lg max-w-sm animate-slide-in"
      style={{ backgroundColor: 'rgba(220, 38, 38, 0.95)' }}
      onClick={onClose}
    >
      <div className="flex items-start gap-2">
        <span className="text-lg">⚠️</span>
        <div className="flex-1 whitespace-pre-line text-sm">
          {error.replace('⚠️ ', '')}
        </div>
        <button className="text-white/70 hover:text-white ml-2">✕</button>
      </div>
    </div>
  );
}

export default FileErrorToast;

